<ng-container *ngIf="rendering.fields.Title">
  <h1 *scText="rendering.fields.Title"></h1>
</ng-container>

<ng-container *ngIf="rendering.fields.Text">
  <section class="" *scRichText="rendering.fields.Text"></section>
</ng-container>
